import { memo, useMemo } from 'react';
import { Field } from 'react-final-form';

import { BaseFileTypeDto } from '@eva/types/dto';
import { FieldBinaryToggle } from 'shared/ui/FieldBinaryToggle/FieldBinaryToggle';
import { Input } from 'shared/ui/Input';
// eslint-disable-next-line import/no-cycle
import { buildOptionGroups, formatFileTypeLabel, formatGroupLabel } from 'shared/ui/Modal/ModalUploadFile';
import { SelectField } from 'shared/ui/SelectField/SelectField';

interface FormFilesFilterProps<FT extends BaseFileTypeDto> {
  fileTypes: FT[];
}

const FormFilesFilter = <FT extends BaseFileTypeDto>({ fileTypes }: FormFilesFilterProps<FT>) => {
  const options = useMemo(() => buildOptionGroups(fileTypes), [fileTypes]);

  return (
    <div>
      <Field name="fileNamePattern" label={translate('Search files')} component={Input} />
      <Field
        multi
        clearable
        name="fileTypes"
        label={translate('Search file types')}
        options={options}
        // @ts-expect-error:
        component={SelectField}
        formatGroupLabel={formatGroupLabel}
        formatOptionLabel={formatFileTypeLabel}
      />
      <div className="margin-bottom">
        <Field
          fluid
          name="verified"
          labelTrue={translate('Verified')}
          labelFalse={translate('Not verified')}
          component={FieldBinaryToggle}
        />
      </div>
      <label>
        <Field type="checkbox" name="expired" formClass="inline-div" valueClass="inline-div" component={Input} />
        <span className="margin-left">{translate('File expired')}</span>
      </label>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(FormFilesFilter);
